import React, { useContext, useId, useRef, useState } from "react";
import "./Delete.css";
import { Context } from "../../context/Context";
import { translations } from "../../utils/lang";
import { Button, Input } from "../ui";
import { useModalLayer, useSubmitGuard } from "./modalHooks";

export const DeleteModal = (props) => {
  const { lang } = useContext(Context);
  const [confirmationText, setConfirmationText] = useState("");
  const titleId = useId();
  const dialogRef = useRef(null);
  // Callers that don't pass `loading` are still protected from double deletes
  // when handleDelete returns a promise.
  const [guardBusy, runDelete] = useSubmitGuard();
  const busy = Boolean(props.loading) || guardBusy;

  const requiredConfirmation =
    lang === "ar" ? "انا متاكد" : "I am confirm";

  const isConfirmationValid =
    confirmationText === requiredConfirmation;

  // Destructive dialog: no backdrop dismissal (unchanged); Escape cancels,
  // except while the delete is running.
  useModalLayer(true, {
    containerRef: dialogRef,
    onEscape: () => {
      if (!busy) props.cancel(null);
    },
  });

  return (
    <div className="delete-container">
      <div
        ref={dialogRef}
        className="delete"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-busy={busy || undefined}
        tabIndex={-1}
      >
        <h4 id={titleId}>{translations[lang].deleteModal.areyousure}</h4>

        {props.description && (
          <p className="delete-description">{props.description}</p>
        )}

        {props.error && (
          <p className="delete-error" role="alert">{props.error}</p>
        )}

        <div className="delete-confirmation">
          <p>
            {lang === "ar"
              ? `الرجاء كتابة "${requiredConfirmation}" للتأكيد`
              : `Write  "${requiredConfirmation}" to confirm`}
          </p>

          <Input
            value={confirmationText}
            onChange={(event) =>
              setConfirmationText(event.target.value)
            }
            placeholder={requiredConfirmation}
            aria-label={requiredConfirmation}
            autoComplete="off"
            autoFocus
            disabled={busy}
          />
        </div>

        <div className="delete-btnn">
          <Button
            variant="danger"
            appearance="filled"
            disabled={!isConfirmationValid || busy}
            loading={busy}
            onClick={() => runDelete(props.handleDelete, props.id)}
          >
            {busy
              ? lang === "ar" ? "جاري الحذف..." : "Deleting..."
              : translations[lang].deleteModal.yes}
          </Button>
        </div>

        <div className="cancel-delete-btn">
          <Button
            variant="primary"
            appearance="soft"
            disabled={busy}
            onClick={() => props.cancel(null)}
          >
            {translations[lang].deleteModal.no}
          </Button>
        </div>
      </div>
    </div>
  );
};
